<template>
  <div
    v-if="visible"
    class="backdrop"
    @click.self="$emit('cancel')"
  >
    <div class="modal">
      <div class="hdr">
        <div class="title">
          {{ title }}
        </div>

        <button
          class="icon-btn tiny"
          type="button"
          title="Close"
          @click="$emit('cancel')"
        >
          ✕
        </button>
      </div>

      <div class="body">
        <Form
          :mode="mode"
          :initial="initial"
          :wallets="wallets"
          :busy="busy"
          :error="error"
          @submit="$emit('submit', $event)"
          @cancel="$emit('cancel')"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import Form from './form.vue'

const props = defineProps({
  visible: { type: Boolean, default: false },
  mode: { type: String, default: 'create' }, // create | copy
  initial: { type: Object, default: null },
  wallets: { type: Array, default: () => [] },
  busy: { type: Boolean, default: false },
  error: { type: String, default: '' },
})

defineEmits(['submit', 'cancel'])

const title = computed(() => {
  return props.mode === 'copy' ? 'Copy coin' : 'Create coin'
})
</script>

<style scoped>
.backdrop{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal{
  width: min(640px, calc(100vw - 32px));
  background: #0b0b0b;
  border: 1px solid #222;
  border-radius: 10px;
  overflow: hidden;
}
.hdr{
  padding: 10px 12px;
  background: #1a1a1a;
  border-bottom: 1px solid #222;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.title{
  font-weight: 600;
  font-size: 13px;
  color: #fff;
}
.body{
  padding: 12px;
}

.icon-btn{
  background: transparent;
  border: 1px solid #333;
  color: #aaa;
  border-radius: 6px;
  cursor: pointer;
  padding: 0;
}
.icon-btn.tiny{
  height: 22px;
  width: 22px;
  line-height: 20px;
  font-size: 11px;
}
.icon-btn:hover{ background:#1a1a1a; }
</style>
